import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_BG: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Астрология',
  components_header_media_multi_content_2: 'Медитация',
  components_header_media_multi_content_3: 'Любов',
  components_header_text1: 'Ръководства',
  components_header_text2: 'Блог',
  hero_text: 'Намерете яснота, баланс и връзка.',
  hero_button_text: 'Започнете пътуването си',
  components_ressources_subheader_text: 'Съвети и вдъхновение',
  components_ressources_span_text: 'Той съчетава лични астрологични прозрения, успокояващи медитационни практики и внимателно напътствие за любовта, за да подпомогне себепознанието, емоционалния баланс и по-дълбоката връзка.',
  components_ressources_card_1_title: 'Съвети за медитация',
  components_ressources_card_1_text: 'Кратко ръководство за по-добро спокойствие, дишане и фокус.',
  components_ressources_card_2_title: 'Любовно напътствие',
  components_ressources_card_2_text: 'Прости съвети за изграждане на по-силна връзка и емоционален баланс.',
  components_ressources_link: 'Открийте повече',
  components_notes_and_google_title_1: 'Намерете яснота',
  components_notes_and_google_title_2: 'Вътрешно спокойствие',
  components_notes_and_google_title_3: 'Сърдечна връзка',
  media_content_section_multi_1_subheader_text: 'Нашият подкаст',
  media_content_section_multi_2_subheader_text: 'Нашите медитации',
  media_content_section_multi_3_subheader_text: 'Истински разговор за космически романс',
  page_media_content_menu_antistress: 'Антистрес',
  page_media_content_menu_mindfulness: 'Внимателност',
  page_media_content_menu_energyboost: 'Енергийно усилване',
  page_media_content_menu_mantra: 'Мантра',
  page_media_content_menu_foundations: 'Фондации',
  page_media_content_menu_spirituality: 'Духовност',
  page_media_content_menu_tarot: 'Таро',
  page_media_content_menu_psychology: 'Психология',
  page_media_content_menu_trends: 'Тенденции',
  page_media_content_menu_compatibility: 'Съвместимост',
  page_media_content_menu_love: 'Любов',
  text2_section_title: 'Блог',
  text2_section_subheader_text: 'Статии и анализи',
  text2_section_button_more: 'Зареди още',
  components_text1_section_title: 'РЪКОВОДСТВА',
  components_text1_subheader_text: 'Космическо знание за ежедневно подравняване',
  components_text1_span_text: 'В хармония с ритмите на вселената: разгледайте подбрана колекция от задълбочени астрологични и медитативни ръководства, предназначени да събудят вътрешна яснота, да задълбочат самосъзнанието и да подкрепят вашето пътуване към духовно, небесно израстване.',
  components_text1_card_1_title: 'Отворено към тишината',
  components_text1_card_1_text: 'Започнете своето пътешествие с ръководства за фундаментална медитация и астрология – идеални за търсещи, привлечени от вътрешна тишина, космически модели и лично прозрение.',
  components_text1_card_3_title: 'Връзка между ума и тялото',
  components_text1_card_3_text: 'Разкрийте по-дълбоките слоеве на вашия вътрешен свят. Тези водачи се движат отвъд повърхността, за да разкрият смисъл, емоция и осъзнати модели, които оформят вашето преживяване.',
  components_text1_card_2_title: 'Размишлявайте и интегрирайте',
  components_text1_card_2_text: 'От емоционални блокажи до планетарни цикли – тези ръководства предлагат инструменти за размисъл, изцеление и трансформация чрез осъзнати ритуали и астрологична мъдрост.',
  components_text1_link: 'Вижте всички ръководства',
  components_footer_text: 'Намерете яснота, балансирайте ума си и се свържете със смисъла – вашето място за астрология, медитация и любов.',
};